module.exports = __webpack_public_path__ + "static/media/thoriacImage1@2x.d85cb884.png";